/**
 * Username generator utility
 * Generates random short usernames for players (max 8 characters guaranteed)
 */

// 4-character adjectives only (ensures 8 char max with 4 char nouns)
const ADJECTIVES = ['Bold', 'Cool', 'Wild', 'Fast', 'Wise', 'Calm', 'Pure', 'True', 'Dark', 'Blue'];

// 4-character nouns only (ensures 8 char max with 4 char adjectives)
const NOUNS = ['Wolf', 'Lion', 'Bear', 'Hawk', 'Lynx', 'Bull', 'Frog', 'Crab', 'Swan', 'Fish'];

/**
 * Generates a random username in format: AdjectiveNoun
 * Guaranteed max 8 characters (4 + 4)
 * Examples: "BoldWolf", "CoolLion", "FastHawk"
 *
 * @returns Random username string (exactly 8 characters)
 */
export function generateRandomUsername(): string {
  const adjective = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  return `${adjective}${noun}`;
}
